function fnTestimonialCarousel( i, oSection ) {

	var oSection				= $( oSection );
	var oCarousel				= oSection.find( '.owl-carousel' );

	$( oCarousel ).owlCarousel({
		items: 					1,
		smartSpeed: 			600,
		dots: 					false,
		nav: 					true,
		loop: 					true,
		margin: 				50,
		autoHeight: 			true,
		autoWidth: 				false,
		mouseDrag: 				true,
		stagePadding: 			0,
		autoplay: 				true,
		autoplayTimeout: 		4500,
		autoplayHoverPause: 	false,
		responsive:			{
			0: {
				stagePadding:	0,
			},
			960: {
				stagePadding: 	150,
			},
			1260: {
				stagePadding: 	250,
			}
		}
	});

}
